export { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
export const source = 'crossFlowProvider';

export const errorBoundaryAction = 'errorCaught';
export const errorBoundaryActionSubject = 'errorBoundary';

export const crossFlowActionSubject = 'crossFlowSupport';
export const uiInitialized = 'uiInitialized';
export const openInvoked = 'openInvoked';
